// overlayKit/Chapter.tsx — STEP card, fullscreen centered.
// Migrated from ChocolateFullPreview inline Chapter.
import React from "react";
import { useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import { appear, FONT, TS, win } from "./utils";
import { useColor } from "./palette";

export type ChapterProps = {
  num: string;
  title: string;
  sub?: string;
  numS: number;
  titleS: number;
  outS: number;
  /** Optional override of the "Step" label text (e.g. "PART"). */
  labelText?: string;
  /** Palette tokens. */
  labelColor?: string;
  numColor?: string;
  accentColor?: string;
  titleColor?: string;
  subColor?: string;
};

export const Chapter: React.FC<ChapterProps> = ({
  num, title, sub, numS, titleS, outS, labelText = "Step",
  labelColor = "cream", numColor = "neutral", accentColor = "secondary",
  titleColor = "primary", subColor = "secondary",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const t = frame / fps;
  const labelS = numS - 0.3;
  const op = win(t, labelS, outS);
  if (op <= 0.001) return null;
  const numScale = spring({ frame: Math.max(0, frame - Math.round(numS * fps)), fps, config: { damping: 12, stiffness: 85 } });
  const numOp = appear(t, numS, 0.12);
  const lineW = interpolate(t, [titleS - 0.15, titleS + 0.5], [0, 150], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const titleOp = appear(t, titleS, 0.16);
  const labelHex = useColor(labelColor);
  const numHex = useColor(numColor);
  const accentHex = useColor(accentColor);
  const titleHex = useColor(titleColor);
  const subHex = useColor(subColor);
  return (
    <div style={{ position: "absolute", inset: 0, fontFamily: FONT, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", opacity: op }}>
      <p style={{ color: labelHex, fontSize: 21, fontWeight: 500, letterSpacing: "0.32em", textTransform: "uppercase", margin: 0, marginBottom: 12, textShadow: TS, opacity: appear(t, labelS, 0.2) }}>{labelText}</p>
      <h1 style={{ color: numHex, fontSize: "9rem", fontWeight: 800, margin: 0, lineHeight: 1, transform: `scale(${numScale})`, textShadow: TS, opacity: numOp }}>{num}</h1>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 20 }}>
        <div style={{ height: 1, width: lineW, backgroundColor: accentHex }} />
        <div style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: accentHex, opacity: titleOp, boxShadow: `0 0 8px ${accentHex}` }} />
        <div style={{ height: 1, width: lineW, backgroundColor: accentHex }} />
      </div>
      <h2 style={{ color: titleHex, fontSize: "2.5rem", fontWeight: 800, letterSpacing: "0.05em", margin: 0, marginTop: 12, textShadow: TS, opacity: titleOp }}>{title}</h2>
      {sub && <p style={{ color: subHex, fontSize: "1.15rem", marginTop: 9, letterSpacing: "0.14em", textShadow: TS, opacity: appear(t, titleS + 0.3, 0.25) }}>{sub}</p>}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
